/* global axios */

import ApiClient from './ApiClient';

class BibleSearchAPI extends ApiClient {
  constructor() {
    super('bible', { accountScoped: true });
  }

  search({ query, translation = 'KJV' }) {
    return axios.get(`${this.url}/search`, {
      params: { query, translation },
    });
  }

  verse({ ref, translation = 'kjv' }) {
    return axios.get(`${this.url}/verse`, {
      params: { ref, translation },
    });
  }
}

export default new BibleSearchAPI();
